import { isReactSnap } from "components/disable-prerender"
import { parseDrugTypesFromUrl } from "hooks/useProductListingAds"
import { Product } from "typings/products"
import { DrugTypeEnum, JourneyAttributesFragment, JourneyKindEnum } from "typings/types"

type getBannerTextProps = {
  cartItems?: Product[]
  journey?: JourneyAttributesFragment | null
  currentVanityUrlBannerText?: string
  currentOfferBannerText?: string
}

export const getBannerText = ({
  cartItems,
  journey,
  currentVanityUrlBannerText,
  currentOfferBannerText
}: getBannerTextProps): string | null => {
  if (isReactSnap) {
    return ""
  } else if (hasEmgalityBanner({ cartItems, journey }) || hasNerivioBanner({ cartItems, journey })) {
    return "Get started with Cove"
  } else if (currentVanityUrlBannerText) {
    return currentVanityUrlBannerText
  } else if (currentOfferBannerText) {
    return currentOfferBannerText
  } else {
    return null
  }
}

export const hasEmgalityBanner = ({ cartItems, journey }: getBannerTextProps): boolean => {
  const onlyEmgalityInCart = cartItems && isOnlyDrugInCart(cartItems, DrugTypeEnum.GalcanezumabGnlm)
  const onlyEmgalityOnJourney = journey && isOnlyDrugOnJourney(journey, DrugTypeEnum.GalcanezumabGnlm)
  const isFromEmgalitySite = windowHasUtmVariable("utm_source=emgality_site")
  const yourInfoHasEmgality = yourInfoHasDrugType(DrugTypeEnum.GalcanezumabGnlm)

  if (onlyEmgalityInCart || onlyEmgalityOnJourney || isFromEmgalitySite || yourInfoHasEmgality) {
    return true
  } else {
    return false
  }
}

export const hasNerivioBanner = ({ cartItems, journey }: getBannerTextProps): boolean => {
  const onlyNerivioInCart = cartItems && isOnlyDrugInCart(cartItems, DrugTypeEnum.Nerivio)
  const onlyNerivioOnJourney = journey && isOnlyDrugOnJourney(journey, DrugTypeEnum.Nerivio)
  const yourInfoHasNerivio = yourInfoHasDrugType(DrugTypeEnum.Nerivio)

  if (onlyNerivioInCart || onlyNerivioOnJourney || yourInfoHasNerivio) {
    return true
  } else {
    return false
  }
}

const isOnlyDrugInCart = (cartItems: Product[], drugType: DrugTypeEnum) =>
  cartItems.length === 1 && cartItems[0].drugType === drugType

const isOnlyDrugOnJourney = (journey: JourneyAttributesFragment, drugType: DrugTypeEnum) =>
  journey.kind === JourneyKindEnum.CovePurchase &&
  journey.userProducts.length === 1 &&
  journey.userProducts[0].drugType === drugType

const windowHasUtmVariable = (utmVariable: string) => {
  const utmQuery = decodeURIComponent(window.location.search.substring(1))
  const utmVariables = utmQuery.split("&")
  return utmVariables.find(utm => utm === utmVariable)
}

const yourInfoHasDrugType = (drugType: DrugTypeEnum) => {
  if (window.location.href.indexOf("purchase/your-info") === -1) {
    return false
  }
  const [drugTypeFromUrl] = parseDrugTypesFromUrl()
  return drugType === drugTypeFromUrl
}
